import React, { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/images/my_logo4.png";
import NewsBanner from "../home/banner";

const WA_LINK = "https://chat.whatsapp.com/YOUR_INVITE_CODE";

const WhatsAppIcon = ({ size = 15 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="#25D366"
    viewBox="0 0 16 16"
    style={{ flexShrink: 0 }}
  >
    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
  </svg>
);

function AppNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      {/* ========== MOBILE & TABLET (< lg) ========== */}
      <div className="d-lg-none">
        {/* Fixed top navbar (logo + hamburger) */}
        <Navbar
          bg="light"
          expand="lg"
          fixed="top"
          style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.08)", padding: "6px 0" }}
        >
          <Container>
            <Navbar.Brand as={Link} to="/">
              <img
                src={logo}
                alt="Logo"
                style={{ height: "40px" }}
                className="img-fluid"
              />
            </Navbar.Brand>

            {/* WhatsApp icon-only button next to hamburger on mobile */}
            <a
              href="https://chat.whatsapp.com/LNfGI3UFWbt69VeUbBoxLj"
              target="_blank"
              rel="noopener noreferrer"
              className="me-2 d-flex align-items-center"
              style={{
                gap: "5px",
                color: "#25D366",
                fontWeight: "600",
                fontSize: "12px",
                textDecoration: "none",
              }}
            >
              <WhatsAppIcon size={20} />
              <span
                className="d-none d-sm-inline"
                style={{ whiteSpace: "nowrap" }}
              >
                WhatsApp Community
              </span>
            </a>

            <Navbar.Toggle aria-controls="mobile-navbar-nav" />

            <Navbar.Collapse id="mobile-navbar-nav">
              <Nav className="ms-auto mt-2 mt-lg-0">
                <Nav.Link as={Link} to="/" style={{ color: "#222" }}>
                  Home
                </Nav.Link>
                <Nav.Link as={Link} to="/sports" style={{ color: "#222" }}>
                  Sports
                </Nav.Link>
                <Nav.Link as={Link} to="/health" style={{ color: "#222" }}>
                  Health
                </Nav.Link>
                <Nav.Link as={Link} to="/technology" style={{ color: "#222" }}>
                  Technology
                </Nav.Link>
                <Nav.Link as={Link} to="/auto" style={{ color: "#222" }}>
                  Auto
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/entertainment"
                  style={{ color: "#222" }}
                >
                  Entertainment
                </Nav.Link>
                <Nav.Link as={Link} to="/immigration" style={{ color: "#222" }}>
                  Immigration
                </Nav.Link>
                <Nav.Link as={Link} to="/heritage" style={{ color: "#222" }}>
                  Heritage
                </Nav.Link>
                <Nav.Link as={Link} to="/travel" style={{ color: "#222" }}>
                  Travel
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Spacer so content isn't hidden under fixed navbar */}
        <div style={{ marginTop: "58px" }} />

        {/* News ticker below navbar — visible on mobile/tablet */}
        <NewsBanner />
      </div>

      {/* ========== DESKTOP (>= lg) ========== */}
      <div className="d-none d-lg-block">
        {/* Line 1: Top info bar */}
        <div
          style={{
            background: "#f8f9fa",
            borderBottom: "1px solid #e0e0e0",
            padding: "9px 0",
            fontSize: "13px",
          }}
        >
          <Container fluid className="px-4">
            <div className="d-flex justify-content-between align-items-center">
              {/* Left: full date */}
              <div style={{ color: "#666" }}>
                {new Date().toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </div>

              {/* Right: WhatsApp */}
              <a
                href="https://chat.whatsapp.com/LNfGI3UFWbt69VeUbBoxLj"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#25D366",
                  fontWeight: "600",
                  fontSize: "13px",
                  textDecoration: "none",
                }}
              >
                <WhatsAppIcon size={16} />
                Join our WhatsApp Community
              </a>
            </div>
          </Container>
        </div>

        {/* Line 2: Centered logo */}
        <div
          style={{
            padding: "22px 0",
            background: "#fff",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Container>
            <div className="text-center">
              <Link to="/">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ height: "80px" }}
                  className="img-fluid"
                />
              </Link>
            </div>
          </Container>
        </div>

        {/* Line 3: Main nav */}
        <Navbar
          bg="white"
          style={{
            borderTop: "0.2px solid #bed7fdff",
            borderBottom: "0.2px solid #e0e0e0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          <Container>
            <Nav className="mx-auto">
              {[
                { label: "Home", to: "/" },
                { label: "Sports", to: "/sports" },
                { label: "Auto", to: "/auto" },
                { label: "Technology", to: "/technology" },
                { label: "Entertainment", to: "/entertainment" },
                { label: "Health", to: "/health" },
                { label: "Immigration", to: "/immigration" },
                { label: "Heritage", to: "/heritage" },
                { label: "Travel", to: "/travel" },
              ].map(({ label, to }) => (
                <Nav.Link
                  key={to}
                  as={Link}
                  to={to}
                  className="px-3 fw-semibold"
                  style={{ color: "#222" }}
                >
                  {label}
                </Nav.Link>
              ))}
            </Nav>
          </Container>
        </Navbar>

        {/* Line 4: News ticker banner */}
        <NewsBanner />

        {/* Sticky navbar on scroll */}
        {scrolled && (
          <Navbar
            bg="white"
            fixed="top"
            style={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderBottom: "0.2px solid #0066ff",
            }}
          >
            <Container>
              <Navbar.Brand as={Link} to="/">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ height: "35px" }}
                  className="img-fluid"
                />
              </Navbar.Brand>
              <Nav className="ms-auto">
                {[
                  { label: "Home", to: "/" },
                  { label: "Sports", to: "/sports" },
                  { label: "Technology", to: "/technology" },
                  { label: "Auto", to: "/auto" },
                  { label: "Health", to: "/health" },
                  { label: "Entertainment", to: "/entertainment" },
                  { label: "Immigration", to: "/immigration" },
                  { label: "Heritage", to: "/heritage" },
                  { label: "Travel", to: "/travel" },
                ].map(({ label, to }) => (
                  <Nav.Link
                    key={to}
                    as={Link}
                    to={to}
                    className="px-3"
                    style={{ color: "#222" }}
                  >
                    {label}
                  </Nav.Link>
                ))}
              </Nav>
            </Container>
          </Navbar>
        )}
      </div>
    </div>
  );
}

export default AppNavbar;
